import {WebGLBrandedDivider} from '@github-ui/brand-webgl'

import Styles from './PageDivider.module.css'

export const PageDivider = () => {
  return (
    <div className={Styles['PageDivider']}>
      <WebGLBrandedDivider
        params={{
          character: 'invertocat',
          layout: 1,
        }}
      />
    </div>
  )
}
